export default __webpack_public_path__ + "static/media/profilebackground.e3513d27.svg";